import { useFormContext } from "react-hook-form";
import InputField from "@medoma/components/InputField/InputField";
import { useLingui } from "@lingui/react/macro";
import {
  informationFieldConfigValueSchema,
  type IInformationFieldConfigValue,
} from "@/api/Patients";

export type MedicalTransportNumberInputFields = {
  medicalTransportNumber: string;
};

const MedicalTransportNumberInput = ({
  medicalTransportNumberFieldConfig,
}: {
  medicalTransportNumberFieldConfig: IInformationFieldConfigValue;
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<MedicalTransportNumberInputFields>();
  const { t } = useLingui();

  return (
    <InputField
      type="text"
      {...register("medicalTransportNumber", {
        pattern: {
          value: /^\d{8}$/,
          message: t`Ange sjukresenummer med 8 siffror`,
        },
        required: {
          value:
            medicalTransportNumberFieldConfig ===
            informationFieldConfigValueSchema.enum.required,
          message: t`Ange sjukresenummer`,
        },
      })}
      label={t`Sjukresenummer`}
      showOptionalLabel={
        medicalTransportNumberFieldConfig ===
        informationFieldConfigValueSchema.enum.optional
      }
      errorMessage={errors.medicalTransportNumber?.message}
    />
  );
};

export default MedicalTransportNumberInput;
